import baseEditForm from 'formiojs/components/_classes/component/Component.form';

import CheckboxValidation from 'formiojs/components/checkbox/editForm/Checkbox.edit.validation';
import CheckboxData from 'formiojs/components/checkbox/editForm/Checkbox.edit.data';
import CheckboxDisplay from 'formiojs/components/checkbox/editForm/Checkbox.edit.display';

export default (...extend) => baseEditForm(
  [
    {
      key: 'display',
      components: CheckboxDisplay,
    },
    {
      key: 'data',
      components: CheckboxData,
    },
    {
      key: 'validation',
      components: CheckboxValidation,
    },
    {
      key: 'addons',
      ignore: true,
    },
    {
      label: 'Custom',
      key: 'custom',
      components: [
        {
          weight: 50,
          type: 'checkbox',
          label: 'Hide Custom Label',
          tooltip:
              'Hide the label (title, if no label) of this component. This allows you to show/hide the custom label when it is rendered.',
          key: 'hideCustomLabel',
          input: true,
        },
      ],
    },
    {
      label: 'Review',
      key: 'review',
      components: [
        {
          weight: 50,
          type: 'checkbox',
          label: 'Use Custom Label',
          tooltip:
              'Use custom label for this component on the review page.',
          key: 'useReviewLabel',
          input: true,
        },
        {
          weight: 100,
          type: 'textfield',
          label: 'Review Page Label',
          key: 'reviewLabel',
          input: true,
        },
      ],
    },
  ],
  ...extend,
);
